// Port of api/fuel/app/classes/model/game/artist.php
import Model from 'offline/stream/model/base'

export default Model.extend({
	table: 'game_artist',
	prefix: '',
	key: 'game_artist_id',
	fields: {
		game_artist_id: Model.SCHEMA_NUMBER,
		game_id: Model.SCHEMA_NUMBER,
		artist_id: Model.SCHEMA_NUMBER
	}
})
